/** One source for visible questions and the homepage FAQ structured data. */
export type HomeFaqItem = { question: string; answer: string };
export const HOME_FAQ_ITEMS: HomeFaqItem[] = [
    {
        question: "Что я получу после подключения TEZAM?",
        answer: "Рабочее пространство CRM, клиентский Telegram Mini App и веб-витрину: каталог или услуги, запись или заказы, клиентов и сотрудников. Набор модулей зависит от направления, ниши и тарифа. Индивидуальный сайт и специальные интеграции согласуются отдельно.",
    },
    {
        question: "Нужно ли создавать бота через BotFather?",
        answer: "При запуске через TEZAM Manager клиентский бот создаётся после подтверждения в Telegram. Вручную копировать токен не нужно. Потребуется аккаунт Telegram у владельца. На сайте также доступен отдельный путь регистрации с дальнейшими шагами подключения.",
    },
    {
        question: "Можно ли начать без программиста?",
        answer: "Да. Вы выбираете нишу, указываете данные бизнеса и проходите настройку. В системе появляется демонстрационное наполнение. Перед приглашением клиентов замените его своим прайсом, проверьте фото, расписание, условия заказа и способы оплаты.",
    },
    {
        question: "Клиенты смогут пользоваться сервисом без Telegram?",
        answer: "Да, клиентская веб-витрина открывается в браузере. Telegram Mini App — дополнительный удобный вход для клиентов, которые пользуются мессенджером. Условия подключения собственного домена и индивидуального сайта уточняются отдельно.",
    },
    {
        question: "За что нужно платить и есть ли комиссия с продаж?",
        answer: "За подписку выбранного тарифа. TEZAM не берёт процент с продаж; комиссии эквайринга и платёжных провайдеров оплачиваются по их условиям. Актуальная стоимость и лимиты — в разделе тарифов. Дополнительные интеграции и помощь с наполнением оцениваются отдельно.",
    },
    {
        question: "Есть ли готовое решение именно для моей сферы?",
        answer: "В каталоге 42 ниши в восьми направлениях: красота, HoReCa, розница, фитнес, услуги, недвижимость, автобизнес и автосервис. Под нишу выбираются настройки и демонстрационные данные. Если у вас нестандартный процесс, команда поможет проверить его до внедрения.",
    },
    {
        question: "Можно ли перенести данные и подключить другие системы?",
        answer: "Объём переноса и формат импорта нужно проверить по вашим данным. Обмен с внешними CRM, учётными системами и специализированными сервисами согласуется отдельно: наличие готовой платформы не означает, что любая интеграция уже подключена.",
    },
];
